var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered",attrs:{"id":"table-fb-default"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Halaman")])])]),_c('tbody')])])
}]

export { render, staticRenderFns }